define('views/modules/feedback/modal/feedback-modal-mixin',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/feedback/modal/feedback-modal',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VFeedbackModal
) {

    return {

        initFeedbackListener: function() {
            this.listenTo(this.collection, { 'show:feedback': this.onShowFeedback });
        },

        getFeedbackModal: function(model) {
            var modal = this.modal;
            if (!modal) {
                this.modal = modal = new VFeedbackModal({
                    model: model
                });
            }
            modal.resetModel(model);
            return modal;
        },

        showFeedbackModal: function(model) {
            if (this.role !== 'supervisor') {
                this.getFeedbackModal(model).render();
            }
        },

        /////////////
        // events //
        /////////////

        onShowFeedback: function(model) {
            // checking if there is an already opened feedback-modal
            if (!(Backbone.$('.feedback-modal').data('bs.modal') || {}).isShown) {
                this.showFeedbackModal(model);
            }
        },
    };
});

